// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1mmij","choiceBoxes":"toolbarselects_choiceBoxes__2ztpe","simpleField":"toolbarselects_simpleField__WjsA2"};